jQuery(function ($) {
	var fixed = $('.js-fixedContent');
	if (fixed.length > 0) {  // .js-fixedContent が存在する場合
		var fixTop = fixed.offset().top - 120;

		function checkScroll() {
			if ($(window).width() >= 769) {  // 769px以上の場合
				$(window).scroll(function () {
					if ($(window).scrollTop() >= fixTop) {
						fixed.addClass('is-fixed');
					} else {
						fixed.removeClass('is-fixed');
					}
				});
			} else {
				fixed.removeClass('is-fixed'); // スクロール位置に関係なく非固定にする
			}
		}

		// 初期チェック
		checkScroll();

		// ウィンドウリサイズ時に再度チェック
		$(window).resize(function () {
			checkScroll();
		});
	}
});